import {VotingResultType} from "@/entities/voting/VotingResultType";

export class VotingStatus {
    result: VotingResultType = VotingResultType.none;
    left: string | null;

    constructor(result: VotingResultType, left: string | null) {
        this.result = result;
        this.left = left;
    }

    hasNoResult() {
        return this.result === VotingResultType.none;
    }
}
